import React from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { observer } from 'mobx-react';

import { ComponentBase, InjectedStyledComponent } from '../../../../../shared/index.js';
import ButtonDay from '../../styledComponents/DatePickerDay/ButtonDay.js';

import { DayClassNameEnum } from './models/DayClassNameEnum.js';
import { IDatePickerDayConfiguration, IDatePickerDayProps, IDatePickerDayState } from './models/index.js';
import {
	DATE_PICKER_DAY_CATEGORY_KEY,
	DATE_PICKER_DAY_COMPONENT_KEY,
	DATE_PICKER_DAY_PARENT_COMPONENT_KEY,
} from './DatePickerDay.meta.js';
export class DatePickerDay extends ComponentBase<
	IDatePickerDayProps,
	IDatePickerDayState,
	IDatePickerDayConfiguration
> {
	categoryKey = DATE_PICKER_DAY_CATEGORY_KEY;
	componentKey = DATE_PICKER_DAY_COMPONENT_KEY;
	get parentComponentKey(): string | undefined {
		return DATE_PICKER_DAY_PARENT_COMPONENT_KEY;
	}

	constructor(props: IDatePickerDayProps) {
		super(props);
	}
	render() {
		const {
			focusedDay,
			today,
			day,
			onDaySelect,
			onKeyboardNavigation,
			focusedDayRef,
			disabled,
			inRange,
			isSelected,
			dateFormatter,
		} = this.props;

		// Is todays day
		const isToday = common.commonUtils.isEqual(day, today);
		// Is a day in the current month
		const isMonth = common.commonUtils.isEqualMonth(day, focusedDay);
		const isFocused = common.commonUtils.isEqual(day, focusedDay);
		// Is not inside min and max date range
		const isOutsideRange = !inRange;

		function handleClick(e: any) {
			onDaySelect(e, day);
		}

		// Builds up dynamic styling which is targeted by the style selectors
		const className: DayClassNameEnum[] = [];
		if (isOutsideRange) {
			className.push(DayClassNameEnum.isOutside);
		}
		if (isToday) {
			className.push(DayClassNameEnum.isToday);
		}
		if (isMonth) {
			className.push(DayClassNameEnum.isMonth);
		}
		if (disabled) {
			className.push(DayClassNameEnum.isDisabled);
		}

		return (
			<ButtonDay
				className={className.join(' ')}
				tabIndex={isFocused ? 0 : -1}
				onClick={handleClick}
				onKeyDown={onKeyboardNavigation}
				aria-disabled={disabled ? 'true' : undefined}
				disabled={isOutsideRange}
				type="button"
				aria-pressed={isSelected ? 'true' : 'false'}
				aria-current={isToday ? 'date' : undefined}
				innerRef={(el: any) => {
					if (isFocused && el && focusedDayRef) {
						focusedDayRef(el);
					}
				}}
			>
				<span aria-hidden="true">{day.getDate()}</span>
				<span className="vhidden">{dateFormatter.format(day)}</span>
			</ButtonDay>
		);
	}
}

export default InjectedStyledComponent(
	observer(DatePickerDay),
	DATE_PICKER_DAY_CATEGORY_KEY,
	DATE_PICKER_DAY_PARENT_COMPONENT_KEY,
	[DATE_PICKER_DAY_COMPONENT_KEY],
);
